import { call, put, delay } from 'redux-saga/effects';
import LayoutData from '@/services/data/LayoutData';
import { SOLDER, defaultMaterial } from '../Stackup/Material';
import { SAVE_STACKUP_TO_SERVER } from '../../pages/LayoutExplorer/components/Stackup_v1/store/actionTypes';
import projectDesigns from './projectDesigns';

const checkedDesigns = new Set();
let checking = false;

export default function* checkMaterialList(designId, projectId) {
  const designIds = projectDesigns.getAvailableDesignIds(projectId);
  if (checkedDesigns.has(designId) || checking || (projectId && !designIds.includes(designId))) return;

  checking = true;

  try {
    yield delay(1000);

    const stackup = yield call(LayoutData.getStackupJson, { pcbId: designId });
    const stackupData = stackup.stackup;
    const materialList = stackupData.materials || [];
    const _materialList = JSON.parse(JSON.stringify(materialList));

    let updated = false;
    if (!materialList.find(item => item.name === SOLDER)) {
      _materialList.push(defaultMaterial[SOLDER]);
      updated = true;
    }

    if (updated) {
      const stackups = yield call(LayoutData.saveStackupJson, designId, {
        data: stackupData.layers,
        materialList: _materialList,
        unit: stackupData.unit
      }, true);
      yield put({ type: SAVE_STACKUP_TO_SERVER, stackupData: stackups, designID: designId });
    }

    checkedDesigns.add(designId);
  } finally {
    checking = false;
  }
}
